module.exports = __webpack_public_path__ + "assets/img/news_bg.0c8efaab.png";